import { environment } from '~app/environment';

import { findOrCreateWuid } from '@breeze/web-lib-wuid';

import { ampli } from '../../ampli';

// Initialize ampli
ampli.load({
  client: {
    apiKey: environment.AMPLITUDE_ANALYTICS_KEY,
    configuration: {
      autocapture: false,
      appVersion: environment.APP_VERSION,
    },
  },
});
ampli.client.setUserId(findOrCreateWuid());

export const analytics = {
  track: {
    calculatorOpened: (merchantUrl?: string) => {
      ampli.calculatorOpened({
        wuid: findOrCreateWuid(),
        merchant_url: merchantUrl,
      });
    },
    applicationCreated: (applicationId: string, merchantUrl?: string) => {
      ampli.applicationCreated({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
        merchant_url: merchantUrl,
      });
    },
    webApplicationFinished: (applicationId: string, merchantUrl?: string) => {
      ampli.webApplicationFinished({
        application_id: applicationId,
        wuid: findOrCreateWuid(),
        merchant_url: merchantUrl,
      });
    },
  },
};
